<div class="container-fluid">
    <div class="row">
        <div class="col-md-12" style="text-align: center;">
            <h1 class="title section-title" style="margin-top: 100px;">Event <span>Schedule</span></h1>
            <h4 class="title section-title" *ngIf="!anyEvents">No Events Scheduled</h4>
        </div>
    </div>
</div>
<div class="container" style="margin-top: 50px;margin-bottom: 100px;">
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6 event-box" *ngFor=" let e of events_pool">
            <div class="container-fluid" style="padding: 15px" angulartics2On="mouseenter"
                angularticsAction="HoveredEvent" angularticsValue="{{e.title}}">
                <div class="row">
                    <div class="col-xs-12 col-sm-3" style="min-height: 141px;"
                        [ngStyle]="{ 'background-image': '-webkit-linear-gradient(top, ' + e.top + ' 0%, ' + e.bottom +' 100% )', 'padding': '35px', 'text-align': 'center', 'color': '#fff' }">
                        <p style="font-size: 55px; margin: 0; line-height: 0.8;">{{e.day}}</p>
                        <p style="font-size: 25px; margin: 0; line-height: 0.8;">{{e.month | uppercase}}</p>
                    </div>
                    <div class="col-xs-12 col-sm-8 col-md-8" style="background: #fff; padding-top: 15px;">
                        <h4 style="line-height: 1.2; font-size: 20px; letter-spacing: 1.5px"><a *ngIf="e.isExternal"
                                href="{{e.url}}" target="_blank">{{e.title | uppercase}}</a><a
                                *ngIf="!e.isExternal">{{e.title | uppercase}}</a></h4>
                        <p class="section-subtext" style="line-height: 1.4; font-size: 16px; margin-bottom: 5px"
                            [innerHtml]="e.shortDescription"></p>
                        <p class="section-subtext" [ngStyle]="{'color': e.top }"
                            style="font-family: 'Quicksand', sans-serif; font-weight: 700; letter-spacing: 0.1px; font-size: 16px;">
                            <strong>{{e.company | uppercase}}</strong></p>
                    </div>
                    <div class="d-none d-sm-block col-sm-1 col-md-1" style="background: #fff"><a class="link-icon"
                            style="position: relative; top: 12px; right: 10px;" href="mailto:{{e.email}}"><img
                                src="../../../assets/members/icons/mailIcon@2x.png" width="20" /></a><a
                            class="link-icon" style="position: relative; top: 28px; right: 10px;"
                            href="https://www.linkedin.com/company/clsq" target="_Blank"><img
                                src="../../../assets/li.png" width="21" /></a><a class="link-icon"
                            *ngIf="e.registration_link.length &gt; 0"
                            style="position: relative; top: 50px; right: 10px; background:transparent"
                            href="{{e.registration_link}}" target="_Blank"><img src="../../../assets/twitter.png"
                                width="21" /></a></div>
                    <div class="d-block d-sm-none col-xs-12"
                        style="background: #fff; width: 100%; padding-top: 20px; padding-bottom: 30px">
                        <div style="display: flex;">
                            <div
                                style="width: 33%; margin-left: auto; margin-right: auto; text-align: center; background:transparent">
                                <a class="link-icon" style="width: 100%;" href="mailto:{{e.email}}"><img
                                        src="../../../assets/members/icons/mailIcon@2x.png" width="20" /></a></div>
                            <div
                                style="width: 33%; margin-left: auto; margin-right: auto; text-align: center; background:transparent">
                                <a class="link-icon" style="width: 100%;" href="https://www.linkedin.com/company/clsq"
                                    target="_Blank"><img src="../../../assets/li.png" width="21" /></a></div>
                            <div
                                style="width: 33%; margin-left: auto; margin-right: auto; text-align: center; background:transparent">
                                <a class="link-icon" *ngIf="e.registration_link.length &gt; 0" style="width: 100%;"
                                    href="{{e.registration_link}}" target="_Blank"><img
                                        src="../../../assets/twitter.png" width="21" /></a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>